import React, { useState } from 'react';
import Modal from './Modal';
import { apiEndpoints } from '../services/api';

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword]         = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading]                 = useState(false);
  const [error, setError]                     = useState('');
  const [success, setSuccess]                 = useState(false);

  const reset = () => {
    setCurrentPassword(''); setNewPassword(''); setConfirmPassword('');
    setError(''); setSuccess(false);
  };

  const handleClose = () => { reset(); onClose(); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmPassword) { setError('New passwords do not match.'); return; }
    if (newPassword.length < 6) { setError('New password must be at least 6 characters.'); return; }
    setLoading(true);
    try {
      await apiEndpoints.auth.changePassword({ currentPassword, newPassword });
      setSuccess(true);
      setTimeout(() => { handleClose(); }, 1600);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to change password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Change Password" size="sm">
      {success ? (
        <div style={{ textAlign: 'center', padding: '24px 0', color: '#10b981', fontWeight: 600, fontSize: 15 }}>
          ✓ Password changed successfully!
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          {error && (
            <div style={{ color: '#dc2626', marginBottom: 14, fontSize: 13, padding: '9px 13px', background: '#fff1f2', border: '1px solid #fecdd3', borderRadius: 8 }}>
              {error}
            </div>
          )}
          <div className="form-group">
            <label className="form-label">Current Password *</label>
            <input type="password" className="form-input" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} required autoComplete="current-password" />
          </div>
          <div className="form-group">
            <label className="form-label">New Password *</label>
            <input type="password" className="form-input" value={newPassword} onChange={e => setNewPassword(e.target.value)} required autoComplete="new-password" />
          </div>
          <div className="form-group">
            <label className="form-label">Confirm New Password *</label>
            <input type="password" className="form-input" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required autoComplete="new-password" />
          </div>
          <div className="form-actions" style={{ marginTop: 6 }}>
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving…' : 'Change Password'}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default ChangePasswordModal;
